module.exports = __webpack_public_path__ + "static/media/android_badge_en.7471a815.svg";